import Vue from "vue";
import Vuex from "vuex";

import user from "./module/user";
import buddy from "./module/buddy";
import app from "./module/app";
import signalr from "./module/signalr";

Vue.use(Vuex);

import "element-ui/lib/theme-chalk/index.css";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    user,
    buddy,
    signalr
  }
});
